"use client";

import { PAASection } from "@/components/sections/paa";
import { paa } from "@/lib/data/services-trend-management";

export function PAA() {
  return (
    <PAASection
      eyebrow={paa.eyebrow}
      title={paa.title}
      items={paa.items}
      accent={paa.accent}
    />
  );
}
